import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const subBookingApi = createApi({
  reducerPath: 'subBookingApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['subBookingApi'],
  endpoints: (builder) => ({
    getCheckInDetails: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.SubBookingDetailController.getCheckInDetails}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetCheckInDetailsMutation
} = subBookingApi;
